// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"GiftsList_bannerContainer__a07Ee","title":"GiftsList_title__9nqAY","subTitle":"GiftsList_subTitle__wDOn9"};